import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useCallback } from 'react';
import { Core } from './Core';
import { CreateTicket } from './CreateTicket';
import { ErrorLog } from './ErrorLog';
import { Initialize } from './Initialize';
import './App.scss';
const modules = {
    'create-ticket': CreateTicket,
    'initialize': Initialize,
};
const pathnameWithoutSlash = window.location.pathname.slice(1);
export const App = () => {
    const [errorLog, setErrorLog] = useState([]);
    const appendToErrorLog = useCallback((errorLine) => {
        setErrorLog(currentErrorLog => [...currentErrorLog, errorLine]);
    }, []);
    const RenderedLog = _jsx(ErrorLog, { errorLog, setErrorLog });
    return (_jsxs(_Fragment, { children: [RenderedLog, (pathnameWithoutSlash === 'create-ticket' || pathnameWithoutSlash === 'initialize')
                ? React.createElement(modules[pathnameWithoutSlash], { appendToErrorLog })
                : _jsx(Core, { appendToErrorLog })] }));
};
